
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,

  TableCell,
  TableContainer,
  TableFooter,

  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  useTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { DatePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import { authorizationHeader, responseBody } from "util/fetchUtil";
import { TokenManager } from "util/TokenManager";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  loadDocumentApprover,
  loadPvelManager,
  loadCustomer,
  loadProjectTemplate,
  createProject,
  createTemplate,
  fetchTemplateDetails,
  updateTemplate,
  loadPrimaryContact,
  getActiveProjects,
  getProjectById,
  updateProject,
} from "./projectsApi";
import { Delete, Edit } from "@material-ui/icons";
import { set } from "lodash";
import { use } from "react";

export const Projects = () => {
  const initialFormValues = {
    Number: "",
    Status: "",
    Salesforce_id: "",
    Name: "",
    Document_Approver: [],
    Customer: [],
    type: "",
    contract_signature: "",
    Pvel_Manager: "",
    template: "",
    template_title: "",
    template_id: null,
  };
  const [hoveredItemId, setHoveredItemId] = useState(null);

  const [isTemplateCall, setTemplateCall] = useState(false);


  const [formValues, setFormValues] = useState(initialFormValues);
  const [DocumentApprover, setDocumentApprover] = useState([]);
  const [loadingDocumentApprover, setLoadingDocumentApprover] = useState(true);

  const [Customer, setCustomer] = useState([]);
  const [customerIds, setCustomerIds] = useState([]);

  const [loadingCustomer, setLoadingCustomer] = useState(true);

  const [PrimaryContact, setPrimaryContact] = useState([]);
  const [loadingPrimarycontact, setLoadingPrimaryContact] = useState(true);

  const [pvelManager, setpvelManager] = useState([]);
  const [loadingpvelManager, setloadingpvelManager] = useState(true);

  const [Template, setTemplate] = useState([]);
  const [loadingTemplate, setLoadingTemplate] = useState(true);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmTemplateDialog, setOpenConfirmtemplateDialog] = useState(false);
  const [openEditProjectDialog, setOpenEditprojectDialog] = useState(false);

  const [errors, setErrors] = useState({});

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);


  const [approverDialogOpen, setApproverDialogOpen] = useState(false);
  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [selectedPrimaryContacts, setSelectedPrimaryContacts] = useState({});
  const [documentApproverNames, setDocumentApproverNames] = useState([]);
  const [primaryContactNames, setPrimaryContactNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [templateData, setTemplateData] = useState(null);


  const [activeProjects, setActiveProjects] = useState({ results: [], count: 0 });
  const [loading, setLoading] = useState(false);
  const [editProcjectId, setEditProjectId] = useState(0);
  const [editProjectData, setEditProjectData] = useState(null);
  const [editProjectFlag, setEditProjectFlag] = useState(false);
  const [ProjectExpanedFlag, setProjectExpanedFlag] = useState(false);
  const [fullPageLoader, setFullPageLoader] = useState(false)

  const [filters, setFilters] = useState({
    projectNumber: "",
  });

  const [filterTrigger, setFilterTrigger] = useState(0);


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const theme = useTheme();




  useEffect(() => {

    setSelectedApprovers((prev) => {
      const updated = Object.fromEntries(
        Object.entries(prev).filter(([custId]) =>
          customerIds.includes(Number(custId))
        )
      );
      return updated;
    });
    setSelectedPrimaryContacts((prev) => {
      const updateContact = Object.fromEntries(
        Object.entries(prev).filter(([custId]) =>
          customerIds.includes(Number(custId))
        )
      );
      return updateContact;
    });

    handleLoadApprover();

  }, [customerIds]);

  useEffect(() => {
    const selectedNames = DocumentApprover.flatMap((cust) =>
      cust.users
        .filter((u) => selectedApprovers[cust.customer_id] === u.url)
        .map((u) => u.username)
    );

    setDocumentApproverNames(selectedNames);
  }, [selectedApprovers, DocumentApprover]);


  useEffect(() => {

    const selectPrimary = PrimaryContact.flatMap((cust) =>
      cust.users
        .filter((u) => selectedPrimaryContacts[cust.customer_id] === u.url)
        .map((u) => u.username)
    );
    setPrimaryContactNames(selectPrimary);
  }, [selectedPrimaryContacts, PrimaryContact]);


  const handleLoadApprover = async () => {
    try {
      if (customerIds.length === 0) return;

      const approver = await loadDocumentApprover(customerIds);
      setDocumentApprover(approver);
      setPrimaryContact(approver);
      setLoadingDocumentApprover(false);
    } catch (error) {
      console.error("Error fetching approver:", error);
      setLoadingDocumentApprover(false);
    }
  };

  const fetchProjects = async (page, limit) => {
    try {
      setLoading(true);
      const response = await getActiveProjects(page, limit, filters);
      setActiveProjects(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchProjects(page, rowsPerPage);
  }, [page, rowsPerPage, filterTrigger]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(rowsPerPage); // reset to first page
  };



  // useEffect(() => {



  //   documentApproverNames && console.info("Selected Approvers Names:", JSON.stringify(documentApproverNames));
  //   primaryContactNames && console.info("Selected Primary Contacts:", JSON.stringify(primaryContactNames));
  //   customerIds && console.info("Customer Ids:", JSON.stringify(customerIds));
  //   selectedCustomer && console.info("Customer List:", JSON.stringify(selectedCustomer));
  //   selectedApprovers && console.info("Document Approver List:", JSON.stringify(selectedApprovers));
  //   selectedPrimaryContacts && console.info("Primary Contact List:", JSON.stringify(selectedPrimaryContacts));

  // }, [selectedApprovers, selectedPrimaryContacts, documentApproverNames, primaryContactNames, customerIds, selectedCustomer]);


  const handleLoadPvelManager = async () => {
    try {
      const fetchedPartners = await loadPvelManager();

      setpvelManager(fetchedPartners);
      setloadingpvelManager(false);
    } catch (error) {
      console.error("Error fetching downstream partners:", error);
      setloadingpvelManager(false);
    }
  };

  const handleLoadCustomer = async () => {
    try {
      const customerList = await loadCustomer();
      setCustomer(customerList);
      setLoadingCustomer(false);
    } catch (error) {
      console.error("Error fetching :", error);
      setLoadingCustomer(false);
    }
  };

  const handleLoadTemplate = async () => {
    try {
      const templateList = await loadProjectTemplate();
      setTemplate(templateList);
      setLoadingTemplate(false);
    } catch (error) {
      console.error("Error fetching :", error);
      setLoadingTemplate(false);
    }
  };




  const Status = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];

  const Type = [
    { value: "DS", label: "Data Services (Includes SSD participants)" },
    { value: "ENGSC", label: "Eng Services/ Strategic Consulting" },
    { value: "FAT", label: "Factory Acceptance Testing" },
    { value: "GOVGRNT", label: "Government Grants" },
    { value: "IFT", label: "Inverter Field Testing (customer site)" },
    { value: "IMISC", label: "Inverter Other (Includes RSD, AFCI)" },
    { value: "IPQP", label: "Inverter PQP" },
    { value: "MFT", label: "Module Field Testing (customer site)" },
    { value: "MHTMI", label: "Module HTMI" },
    { value: "MMISC", label: "Module Other" },
    { value: "MFPID", label: "Module Flash, PAN, IAM, DML" },
    { value: "MPQP", label: "Module PQP" },
    { value: "PVUSA", label: "PV-USA (Includes Tracker/CEY)" },
    { value: "REFC", label: "Ref Cells" },
    { value: "SMISC", label: "Storage Other" },
    { value: "SPQP", label: "Storage PQP" },
    { value: "SBURN", label: "Storage - Burn" },
    { value: "PEO", label: "Power Electronics Other" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleAutoChange = (name, newValue) => {
    setFormValues((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleDateChange = (name, date) => {
    const formattedDate = format(new Date(date), "yyyy-MM-dd");
    setFormValues((prev) => ({ ...prev, [name]: formattedDate }));
  };

  const clearForm = () => {
    setFormValues(initialFormValues);
    setTemplateCall(false);
    setDocumentApproverNames([]);
    setPrimaryContactNames([]);
    setSelectedCustomer([]);
    setCustomerIds([]);
    setSelectedApprovers({});
    setSelectedPrimaryContacts({});
    setTemplateData(null);
    setCustomer([]);

    setLoading(false)
    setEditProjectId(0)
    setEditProjectData(null)
    setEditProjectFlag(false)

  };

  const handleFilterSearch = () => {
    setPage(0);
    setFilterTrigger(t => t + 1);
  };


  const handleClearFilters = () => {
    setFilters({ projectNumber: "" });
    setPage(0);
    setFilterTrigger(t => t + 1);
  };


  const validateForm = (requireTemplateTitle = false) => {
    const newErrors = {};

    if (!formValues.Number) {
      newErrors.Number = "Project number is required";
    }
    if (!formValues.Status) newErrors.Status = "Status is required";
    if (!formValues.Salesforce_id)
      newErrors.Salesforce_id = "Salesforce ID is required";
    if (!formValues.Name) newErrors.Name = "Name is required";
    if (!formValues.Document_Approver || formValues.Document_Approver.length === 0)
      newErrors.Document_Approver = "At least one Document Approver is required";
    if (!formValues.Customer || formValues.Customer.length === 0)
      newErrors.Customer = "Customer is required";
    if (!formValues.type) newErrors.type = "Type is required";
    if (!formValues.contract_signature)
      newErrors.contract_signature = "Contract Signature is required";

    if (!formValues.Pvel_Manager)
      newErrors.Pvel_Manager = "PVEL Manager is required";

    if (requireTemplateTitle && !formValues.template_title) {
      newErrors.template_title = "Template title is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleEditProject = async (id) => {

    setEditProjectId(id);

    setEditProjectFlag(true);
    await Promise.all([
      handleLoadCustomer(),
      handleLoadApprover(),
      handleLoadPvelManager(),
    ]);
    // console.log("project with ID:", id);
    try {
      const data = await getProjectById(id);
      setEditProjectData(data);
      console.info("log", data)

      setFormValues((prev) => ({
        ...prev,
        Number: data.number || prev.Number,
        Status: data.status || prev.Status,
        Salesforce_id: data.salesforce_id || prev.Salesforce_id,
        Name: data.name || prev.Name,
        Document_Approver: data.document_approver || prev.Document_Approver,
        Customer: data.customer?.map((c) => c.url) || prev.Customer,
        type: data.type || prev.type,
        contract_signature: data.contract_signature
          ? format(new Date(data.contract_signature), "yyyy-MM-dd")
          : prev.contract_signature,
        Pvel_Manager: data.pvel_manager || prev.Pvel_Manager,
        template_title: data.template_title || prev.template_title,
      }));


      setSelectedCustomer(data.customer?.map(c => c.url) || []);
      setCustomerIds(data.customer.map((c) => c.id));

      if (data.custom_response?.length) {
        const approvers = {};
        const primaryContacts = {};
        data.custom_response.forEach((item) => {
          approvers[item.customer_id] =
            item.document_approver_id
              ? `https://portolaprod.azurewebsites.net/api/users/${item.document_approver_id}/`
              : "";

          primaryContacts[item.customer_id] =
            item.primary_contact_id
              ? `https://portolaprod.azurewebsites.net/api/users/${item.primary_contact_id}/`
              : "";
        });

        setSelectedApprovers(approvers);
        setSelectedPrimaryContacts(primaryContacts);
      }



      setDocumentApproverNames(data.document_approver_name || []);
      setPrimaryContactNames(data.primary_contact_name || []);
    } catch (err) {

      console.error("Submission error:", err);
      toast.error("Project creation failed.", err);
    }


  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formValues);
    if (!validateForm()) {
      toast.error("Please fill out all required fields.");
      return;
    }
    const customersData = customerIds
      .map((custId) => {
        const approverUrl = selectedApprovers[custId];
        if (!approverUrl) return null; // no approver selected

        const parts = approverUrl.split("/").filter(Boolean);
        const document_approver_id = parseInt(parts[parts.length - 1], 10);


        if (isNaN(document_approver_id)) return null; // invalid number

        const primaryContactUrl = selectedPrimaryContacts[custId];

        if (!primaryContactUrl) return null; // no approver selected

        const primaryContactSplit = primaryContactUrl.split("/").filter(Boolean);
        const primary_contact_id = parseInt(primaryContactSplit[primaryContactSplit.length - 1], 10);


        if (isNaN(primary_contact_id)) return null;
        return {
          customer_id: custId,
          document_approver_id,
          primary_contact_id,
        };
      })
      .filter(Boolean); // remove nulls

    const formData = new FormData();
    formData.append("number", formValues.Number);
    formData.append("status", formValues.Status);
    formData.append("salesforce_id", formValues.Salesforce_id);
    formData.append("name", formValues.Name);
    formData.append("customers", JSON.stringify(customersData)); // ✅ merged array
    formData.append("type", formValues.type);
    formData.append("contract_signature", formValues.contract_signature);
    formData.append("pvel_manager", formValues.Pvel_Manager);
    formData.append("template_title", formValues.template_title);


    try {
      const response = await createProject(formData);

      if (response.ok) {
        setOpenConfirmDialog(true)
        toast.success("Project created successfully.",
          //   {
          //   onClose: () => window.location.reload(),
          //   autoClose: 3000,
          // }
        );
        clearForm();
      } else {
        const errorText = await response.text();
        console.error("Submission failed:", errorText);
        toast.error(`Project creation failed. ${errorText}`);
      }
    } catch (err) {
      // console.log("customer id", customerIds);
      console.error("Submission error:", err);
      toast.error("Project creation failed.", err);
    }
  };
  const validateApproverAndPrimaryContact = () => {
    const missingApprovers = [];
    const missingPrimaryContacts = [];

    customerIds.forEach((custId) => {
      if (!selectedApprovers[custId]) {
        missingApprovers.push(custId);
      }

      if (!selectedPrimaryContacts[custId]) {
        missingPrimaryContacts.push(custId);
      }
    });

    if (missingApprovers.length || missingPrimaryContacts.length) {
      let message = "";

      if (missingApprovers.length) {
        message += "Please select Document Approver for all selected customers. ";
      }

      if (missingPrimaryContacts.length) {
        message += "Please select Primary Contact for all selected customers.";
      }

      toast.warning(message);
      return false;
    }

    return true;
  };



  const handleUpdate = async () => {
    console.info("edit form values", formValues)

    if (!validateForm()) {
      toast.error("Please fill out all required fields.");
      return;
    }
    if (!validateApproverAndPrimaryContact()) return;

    const customersData = customerIds
      .map((custId) => {
        const approverUrl = selectedApprovers[custId];
        if (!approverUrl) return null; // no approver selected

        const parts = approverUrl.split("/").filter(Boolean);
        const document_approver_id = parseInt(parts[parts.length - 1], 10);

        if (isNaN(document_approver_id)) return null; // invalid number

        const primaryContactUrl = selectedPrimaryContacts[custId];

        if (!primaryContactUrl) return null; // no approver selected

        const primaryContactSplit = primaryContactUrl.split("/").filter(Boolean);
        const primary_contact_id = parseInt(primaryContactSplit[primaryContactSplit.length - 1], 10);


        if (isNaN(primary_contact_id)) return null;
        return {
          customer_id: custId,
          document_approver_id,
          primary_contact_id,
        };
      })
      .filter(Boolean); // remove nulls

    const formData = new FormData();
    formData.append("number", formValues.Number);
    formData.append("status", formValues.Status);
    formData.append("salesforce_id", formValues.Salesforce_id);
    formData.append("name", formValues.Name);
    formData.append("customers", JSON.stringify(customersData)); // ✅ merged array
    formData.append("type", formValues.type);
    formData.append("contract_signature", formValues.contract_signature);
    formData.append("pvel_manager", formValues.Pvel_Manager);
    formData.append("project_id", editProcjectId.toString());

    console.log("submitted form values", formData)



    try {
      const response = await updateProject(formData);

      if (response.ok) {
        setOpenEditprojectDialog(true)
        toast.success("Project Updated successfully.",
          //   {
          //   onClose: () => window.location.reload(),
          //   autoClose: 3000,
          // }
        );
        clearForm()
      } else {
        const errorText = await response.text();
        console.error("Submission failed:", errorText);
        toast.error(`Failed to update project: ${errorText}`);
      }
    } catch (err) {
      // console.log("customer id", customerIds);
      console.error("Submission error:", err);
      toast.error("Project creation failed.", err);
    }
  }




  const handleTemplateChange = async (e) => {
    // 🟢 Wait for customer and approver lists before continuing
    await Promise.all([
      handleLoadCustomer(),
      handleLoadApprover(),
      handleLoadPvelManager(),
    ]);

    const selectedUrl = e.target.value;
    const selectedTemplate = Template.results.find(
      (item) => item.url === selectedUrl
    );

    setFormValues((prev) => ({
      ...prev,
      template: selectedUrl,
      template_id: selectedTemplate?.id || null,
    }));

    try {
      const data = await fetchTemplateDetails(selectedUrl);
      setTemplateCall(true);
      setTemplateData(data);

      // 1️⃣ Update form values
      setFormValues((prev) => ({
        ...prev,
        Number: data.number || prev.Number,
        Status: data.status || prev.Status,
        Salesforce_id: data.salesforce_id || prev.Salesforce_id,
        Name: data.name || prev.Name,
        Document_Approver: data.document_approver || prev.Document_Approver,
        Customer: data.customer?.map((c) => c.url) || prev.Customer,
        type: data.type || prev.type,
        contract_signature: data.contract_signature
          ? format(new Date(data.contract_signature), "yyyy-MM-dd")
          : prev.contract_signature,
        Pvel_Manager: data.pvel_manager || prev.Pvel_Manager,
        template_title: data.template_title || prev.template_title,
      }));

      if (data.customer?.length) {

        setSelectedCustomer(data.customer.map((cust) => cust));
        setCustomerIds(data.customer.map((c) => c.id));
      }

      // ✅ Approver logic
      if (data.custom_response?.length) {
        setSelectedApprovers(
          Object.fromEntries(
            data.custom_response.map((item) => [
              item.customer_id,
              item.document_approver_id
                ? `https://portolaprod.azurewebsites.net/api/users/${item.document_approver_id}/`
                : "",
            ])
          )
        );

        setSelectedPrimaryContacts(
          Object.fromEntries(
            data.custom_response.map((item) => [
              item.customer_id,
              item.primary_contact_id
                ? `https://portolaprod.azurewebsites.net/api/users/${item.primary_contact_id}/`
                : "",
            ])
          )
        );
      }

      setDocumentApproverNames(data.document_approver_name || []);
      setPrimaryContactNames(data.primary_contact_name || []);
    } catch (err) {
      console.error("Error fetching selected template data:", err);
      toast.error("Failed to load template details.");
    }
  };



  const handleDeleteTemplate = async (id) => {
    try {

      const response = await fetch(
        `https://portolaprod.azurewebsites.net/api/project_template/${id}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: authorizationHeader(TokenManager.getToken()),
          },
          body: JSON.stringify({ active: false }),
        }
      );

      if (response.ok) {
        // console.log(`Template with ID ${id} deactivated successfully.`);
        toast.success("Template marked as inactive.");
        setTemplate((prevTemplate) => ({
          ...prevTemplate,
          results: prevTemplate.results.filter((item) => item.id !== id),
        }));
        clearForm();
      } else {
        console.error("Patch failed:", await response.text());
        toast.error("Failed to update the template.");
      }
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error("Something went wrong.");
    }
  };

  const handleSubmitTemplate = async (e, shouldSubmitEntityAfter = false) => {
    e.preventDefault();
    // console.log("Submit template:", formValues);
    // console.log("customer id", customerIds);
    if (!validateForm(true)) {
      toast.error(
        "Please fill out all required fields including template title."
      );
      return;
    }

    const customersData = customerIds
      .map((custId) => {
        const approverUrl = selectedApprovers[custId];
        if (!approverUrl) return null; // no approver selected

        const parts = approverUrl.split("/").filter(Boolean);
        const document_approver_id = parseInt(parts[parts.length - 1], 10);

        if (isNaN(document_approver_id)) return null; // invalid number

        const primaryContactUrl = selectedPrimaryContacts[custId];

        if (!primaryContactUrl) return null; // no approver selected

        const primaryContactSplit = primaryContactUrl.split("/").filter(Boolean);
        const primary_contact_id = parseInt(primaryContactSplit[primaryContactSplit.length - 1], 10);


        if (isNaN(primary_contact_id)) return null;
        return {
          customer_id: custId,
          document_approver_id,
          primary_contact_id,
        };
      })
      .filter(Boolean); // remove nulls

    const formData = new FormData();
    formData.append("number", formValues.Number);
    formData.append("status", formValues.Status);
    formData.append("salesforce_id", formValues.Salesforce_id);
    formData.append("name", formValues.Name);
    formData.append("customers", JSON.stringify(customersData)); // ✅ merged array
    formData.append("type", formValues.type);
    formData.append("contract_signature", formValues.contract_signature);
    formData.append("pvel_manager", formValues.Pvel_Manager);
    formData.append("template_title", formValues.template_title);
    // console.log("template id", formData);

    try {
      const response = await createTemplate(formData);

      if (!response.ok) {
        toast.error(
          "Template creation failed Please note that the Template and Project Number have already been used"
        );
      } else {
        // if (shouldSubmitEntityAfter) {
        //   handleSubmit(e);
        // }
        setOpenConfirmtemplateDialog(true)
        toast.success("Template created successfully.",
          //    {
          //   onClose: () => window.location.reload(),
          //   autoClose: 3000, // optional
          // }
        );
        clearForm();
      }
    } catch (err) {
      console.error("Template submission error:", err);
      toast.error("Failed to save template.", err);
    }
  };

  const handleSaveTemplate = async (e, shouldSubmitEntityAfter = false) => {
    e.preventDefault();
    // console.log("Saving template:", formValues);
    if (!validateForm(true)) {
      toast.error(
        "Please fill out all required fields including template title."
      );
      return;
    }

    const formData = new FormData();

    formData.append("number", formValues.Number);
    formData.append("status", formValues.Status);
    formData.append("salesforce_id", formValues.Salesforce_id);
    formData.append("name", formValues.Name);
    // formData.append("document_approver", formValues.Document_Approver);
    formData.append("customer", JSON.stringify(formValues.Customer));
    formData.append("type", formValues.type);
    formData.append("contract_signature", formValues.contract_signature);
    formData.append("pvel_manager", formValues.Pvel_Manager);
    formData.append("template_title", formValues.template_title);

    try {
      const response = await updateTemplate(formData, formValues.template_id);

      if (!response.ok) {
        toast.error(
          "Template creation failed Please note that the Template and Project Number have already been used"
        );
      } else {
        if (shouldSubmitEntityAfter) {
          handleSubmit(e);
        }
        toast.success("Template created successfully.", {
          onClose: () => window.location.reload(),
          autoClose: 3000, // optional
        });
        clearForm();
      }
    } catch (err) {
      console.error("Template submission error:", err);
      toast.error("Failed to save template.", err);
    }
  };

  return (
    <>
      <Paper>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} style={{ padding: 40 }}>
            {/* <Grid item xs={12}> */}
            <Grid item xs={6}>
              {editProjectFlag ? null : (

                <TextField
                  fullWidth
                  name="template_title"
                  label="Template Title"
                  placeholder="Enter template title"
                  value={formValues.template_title}
                  onChange={handleChange}
                  disabled={editProjectFlag}
                  error={!!errors.template_title}
                  helperText={errors.template_title}
                />

              )}
            </Grid>

            <Grid item xs={6}>
              {editProjectFlag ? null : (

                <FormControl fullWidth>
                  <InputLabel id="type-label">Template</InputLabel>
                  <Select
                    labelId="Template-label"
                    name="template"
                    placeholder="Select template"
                    value={formValues.template}
                    disabled={editProjectFlag}
                    onOpen={handleLoadTemplate}
                    onChange={handleTemplateChange}
                  >
                    {loadingTemplate ? (
                      <MenuItem value="">Loading...</MenuItem>
                    ) : (
                      Template.results.map((option) => (
                        <MenuItem
                          key={option.id}
                          value={option.url}
                          onMouseEnter={() => setHoveredItemId(option.id)}
                          onMouseLeave={() => setHoveredItemId(null)}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            width="100%"
                          >
                            <span>{option.template_title}</span>

                            {hoveredItemId === option.id && (
                              <Delete
                                fontSize="small"
                                sx={{ color: "red", cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedTemplateId(option.id);
                                  setOpenDeleteDialog(true);
                                }}
                              />
                            )}
                          </Box>
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              )}
            </Grid>


            <Grid item xs={6}>
              <TextField
                fullWidth
                name="Number"
                label="Number"
                placeholder="Enter the project number"
                value={formValues.Number}
                onChange={handleChange}
                disabled={editProjectFlag}
                required
                error={!!errors.Number}
                helperText={errors.Number}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={Status}
                getOptionLabel={(option) => option.label}
                value={
                  Status.find((opt) => opt.value === formValues.Status) || null
                }
                onChange={(e, newValue) =>
                  handleAutoChange("Status", newValue?.value || "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    placeholder="Select Status"
                    required
                    error={!!errors.Status}
                    helperText={errors.Status}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="Salesforce_id"
                label="Salesforce id"
                placeholder="Enter the Salesforce Id"
                value={formValues.Salesforce_id}
                onChange={handleChange}
                required
                error={!!errors.Salesforce_id}
                helperText={errors.Salesforce_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="Name"
                label="Name"
                placeholder="Enter the Name"
                disabled={editProjectFlag}
                value={formValues.Name}
                onChange={handleChange}
                required
                error={!!errors.Name}
                helperText={errors.Name}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={Type}
                getOptionLabel={(option) => option.label}
                value={Type.find((opt) => opt.value === formValues.type) || null}
                onChange={(e, newValue) =>
                  handleAutoChange("type", newValue?.value || "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Type"
                    required
                    error={!!errors.type}
                    helperText={errors.type}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <DatePicker
                label="Contract Signature"
                value={
                  formValues.contract_signature
                    ? new Date(formValues.contract_signature)
                    : null
                }
                onChange={(date) => handleDateChange("contract_signature", date)}
                format="yyyy-MM-DD"
                fullWidth
                required
                clearable
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={pvelManager}
                getOptionLabel={(option) => option.username || ""}
                loading={loadingpvelManager}
                onOpen={handleLoadPvelManager}
                value={
                  pvelManager.find((e) => e.url === formValues.Pvel_Manager) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "Pvel_Manager",
                      value: newValue ? newValue.url : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="PVEL Manager"
                    placeholder="Select PVEL Manager"
                    required
                    error={!!errors.Pvel_Manager}
                    helperText={errors.Pvel_Manager}
                  />
                )}
                isOptionEqualToValue={(option, value) => option.url === value.url}
              />
            </Grid>

            <Grid item xs={6}>

              <Autocomplete
                multiple
                disableCloseOnSelect
                options={Customer}
                getOptionLabel={(option) => option.legal_name || ""}
                loading={loadingCustomer}
                onOpen={handleLoadCustomer}
                value={Customer.filter((e) =>
                  formValues.Customer?.includes(e.url)
                )}
                onChange={(event, newValue) => {
                  const selectedCustomers = newValue.map((item) => item.url);
                  const selectedIds = newValue.map((item) => item.id);

                  // console.log("Selected customer URLs:", selectedCustomers);

                  handleChange({
                    target: {
                      name: "Customer",
                      value: selectedCustomers,
                    },
                  });
                  setCustomerIds(selectedIds);
                  setSelectedCustomer(newValue);


                  if (selectedCustomers.length === 0) {
                    handleChange({
                      target: {
                        name: "Document_Approver",
                        value: "",
                      },
                    });
                  }
                }}
                renderTags={(value, getTagProps) => (
                  <Box
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      gap: 0.5,
                    }}
                  >
                    {value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.legal_name}
                        style={{ flexShrink: 0 }}
                      />
                    ))}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Customer"
                    placeholder="Select Customers"
                    required
                    error={!!errors.Customer}
                    helperText={errors.Customer}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.url === value.url
                }
              />
            </Grid>


            <Grid item xs={6}>

              <TextField
                fullWidth
                label="Document Approver *"
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { color: "green" },
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        padding: "4px 0",
                        minHeight: 32,
                      }}
                    >
                      {documentApproverNames.length > 0 ? (
                        documentApproverNames.map((name, index) => (
                          <Chip
                            key={index}
                            label={name}
                            size="small"
                            style={{
                              backgroundColor: "#000",
                              color: "#fff",
                            }}
                          />
                        ))
                      ) : (
                        <span style={{ color: "#9e9e9e" }}>Select Document Approver</span>
                      )}
                    </div>
                  ),
                }}
                onClick={() => {
                  if (!selectedCustomer) return; // disable click
                  handleLoadApprover?.();
                  setApproverDialogOpen(customerIds.length > 0);
                }}
                style={{
                  backgroundColor: selectedCustomer ? "#fff" : "#f5f5f5",
                  opacity: selectedCustomer ? 1 : 0.6,
                  cursor: selectedCustomer ? "pointer" : "not-allowed",
                  pointerEvents: selectedCustomer ? "auto" : "none",
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Primary Contact *"
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                  style: { color: "green" },
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        padding: "4px 0",
                        minHeight: 32,
                      }}
                    >
                      {primaryContactNames.length > 0 ? (
                        primaryContactNames.map((name, index) => (
                          <Chip
                            key={index}
                            label={name}
                            size="small"
                            style={{
                              backgroundColor: "#000",
                              color: "#fff",
                            }}
                          />
                        ))
                      ) : (
                        <span style={{ color: "#9e9e9e" }}>Select Primary contact</span>
                      )}
                    </div>
                  ),
                }}

                style={{
                  backgroundColor: selectedCustomer ? "#fff" : "#f5f5f5",
                  opacity: selectedCustomer ? 1 : 0.6,
                  cursor: selectedCustomer ? "pointer" : "not-allowed",
                  pointerEvents: selectedCustomer ? "auto" : "none",
                }}
              />
            </Grid>


            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  // type="submit"
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={editProjectFlag ? handleUpdate : handleSubmit}
                >
                  {editProjectFlag ? "Update project" : "Submit Project"}
                </Button>
                {/* <Button
                type="button"
                variant="contained"
                color="primary"
                style={{ marginLeft: 10 }}
                onClick={(e) => {
                  handleSaveTemplate(e, false);
                }}
                disabled={!formValues.template_title.trim()}
              >
                Save Template
              </Button> */}

                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  disabled={editProjectFlag}
                  onClick={(e) => {
                    handleSubmitTemplate(e, false);
                  }}
                >
                  Save As Template
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={clearForm}
                >
                  Clear
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>


        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Delete Template</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this template?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleDeleteTemplate(selectedTemplateId);
                setOpenDeleteDialog(false);
              }}
              color="primary"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The Project has been submitted successfully.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenConfirmDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>

        <Dialog
          open={openConfirmTemplateDialog}
          onClose={() => setOpenConfirmtemplateDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The Project has been successfully saved as a template.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenConfirmtemplateDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>

        <Dialog
          open={openEditProjectDialog}
          onClose={() => setOpenEditprojectDialog(false)}
        >
          <DialogTitle>Confirmation status</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The Project has been Updated successfully .

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setOpenEditprojectDialog(false);
                window.location.reload();
              }}
              color="secondary"
            >
              ok
            </Button>

          </DialogActions>
        </Dialog>


        <Dialog
          open={approverDialogOpen}
          onClose={() => setApproverDialogOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Select Document Approver & Primary Contact</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={3}>
              {/* Left: Document Approver */}
              <Grid item xs={12} md={6}>
                <Box border={1}
                  borderColor="grey.300"
                  borderRadius={8}
                  p={2}
                  boxShadow={1}
                  height="100%">
                  <strong style={{ fontSize: 16 }}>Select Document Approver</strong>
                  <Box mt={2}>
                    {DocumentApprover.length === 0 ? (
                      <CircularProgress />
                    ) : (
                      DocumentApprover.map((cust) => (
                        <Box key={cust.customer_id} mb={2}>
                          <strong>{cust.customer_name}</strong>
                          {cust.users.length === 0 ? (
                            <Box ml={2} color="gray">
                              No users available
                            </Box>
                          ) : (
                            cust.users.map((user) => (
                              <Box
                                key={user.id}
                                display="flex"
                                alignItems="center"
                                ml={2}
                                mt={0.5}
                              >
                                <input
                                  type="radio"
                                  name={`approver-${cust.customer_id}`}
                                  value={user.url}
                                  checked={selectedApprovers[cust.customer_id] === user.url}
                                  onChange={() =>
                                    setSelectedApprovers((prev) => ({
                                      ...prev,
                                      [cust.customer_id]: user.url,
                                    }))
                                  }
                                  style={{ marginRight: 8 }}
                                />
                                <span>{user.username}</span>
                              </Box>
                            ))
                          )}
                        </Box>
                      ))
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* Right: Primary Contact */}
              <Grid item xs={12} md={6} >
                <Box border={1}
                  borderColor="grey.300"
                  borderRadius={8}
                  p={2}
                  boxShadow={1}
                  height="100%">
                  <strong style={{ fontSize: 16 }}>Select Primary Contact</strong>
                  <Box mt={2}>
                    {PrimaryContact.length === 0 ? (
                      <CircularProgress />
                    ) : (
                      PrimaryContact.map((cust) => (
                        <Box key={cust.customer_id} mb={2}>
                          <strong>{cust.customer_name}</strong>
                          {cust.users.length === 0 ? (
                            <Box ml={2} color="gray">
                              No contacts available
                            </Box>
                          ) : (
                            cust.users.map((user) => (
                              <Box
                                key={user.id}
                                display="flex"
                                alignItems="center"
                                ml={2}
                                mt={0.5}
                              >
                                <input
                                  type="radio"
                                  name={`primary-${cust.customer_id}`}
                                  value={user.url}
                                  checked={selectedPrimaryContacts[cust.customer_id] === user.url}
                                  onChange={() =>
                                    setSelectedPrimaryContacts((prev) => ({
                                      ...prev,
                                      [cust.customer_id]: user.url,
                                    }))
                                  }
                                  style={{ marginRight: 8 }}
                                />
                                <span>{user.username}</span>
                              </Box>
                            ))
                          )}
                        </Box>
                      ))
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setApproverDialogOpen(false)} color="secondary">
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                // --- Validation logic ---
                const missingApprovers = DocumentApprover.filter(
                  (cust) => cust.users.length > 0 && !selectedApprovers[cust.customer_id]
                ).map((cust) => cust.customer_name);

                const missingPrimaryContacts = PrimaryContact.filter(
                  (cust) => cust.users.length > 0 && !selectedPrimaryContacts[cust.customer_id]
                ).map((cust) => cust.customer_name);

                if (missingApprovers.length > 0 || missingPrimaryContacts.length > 0) {
                  let message = "";

                  if (missingApprovers.length > 0) {
                    message += `Please select Document Approver for: ${missingApprovers.join(", ")}. `;
                  }

                  if (missingPrimaryContacts.length > 0) {
                    message += `Please select Primary Contact for: ${missingPrimaryContacts.join(", ")}.`;
                  }

                  toast.warning(message); // shows warning toast
                  return; // stop further execution
                }

                // --- If validation passes ---
                const selectedApproverNames = DocumentApprover.flatMap((cust) =>
                  cust.users
                    .filter((u) => selectedApprovers[cust.customer_id] === u.url)
                    .map((u) => u.username)
                );
                const selectedPrimaryNames = PrimaryContact.flatMap((cust) =>
                  cust.users
                    .filter((u) => selectedPrimaryContacts[cust.customer_id] === u.url)
                    .map((u) => u.username)
                );

                handleChange({
                  target: {
                    name: "Document_Approver",
                    value: Object.values(selectedApprovers),
                  },
                });

                handleChange({
                  target: {
                    name: "Primary_Contact",
                    value: Object.values(selectedPrimaryContacts),
                  },
                });

                setDocumentApproverNames(selectedApproverNames);
                setPrimaryContactNames(selectedPrimaryNames);
                setApproverDialogOpen(false);
              }}
            >
              Select
            </Button>

          </DialogActions>
        </Dialog>


      </Paper>

      <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
        <Grid item style={{ marginTop: "20px" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              clearForm();
              setProjectExpanedFlag(!ProjectExpanedFlag);

            }}

          >
            Update Project Informtion
          </Button>
        </Grid>
      </Grid >

      {ProjectExpanedFlag && (
        <>

          <Grid container spacing={2} style={{ margin: "10px" }}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="Project Number"
                size="small"
                value={filters.projectNumber}
                onChange={(e) =>
                  setFilters({ ...filters, projectNumber: e.target.value })
                }
              />
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} sm={6} md={2}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleFilterSearch}
              >
                Search
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleClearFilters}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Paper style={{ margin: "20px 10px" }}>
            <TableContainer
              style={{ height: "1000px" }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow style={theme.tableHeaderRow}>
                    <TableCell style={theme.tableHeader}>Project Number</TableCell>
                    <TableCell style={theme.tableHeader}>Status</TableCell>
                    <TableCell style={theme.tableHeader}>Name</TableCell>
                    <TableCell style={theme.tableHeader}>Contract Signature</TableCell>
                    <TableCell style={theme.tableHeader}>Salesforce Id</TableCell>
                    <TableCell style={theme.tableHeader}>Project Type</TableCell>
                    <TableCell style={theme.tableHeader}>PVEL Manager</TableCell>
                    <TableCell style={theme.tableHeader}>Edit</TableCell>
                  </TableRow>
                </TableHead>

                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Box display="flex" justifyContent="center" p={4}>
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {activeProjects.results.map((project) => (
                      <TableRow key={project.id}>
                        <TableCell>{project.number || "N/A"}</TableCell>
                        <TableCell>{project.status || "N/A"}</TableCell>
                        <TableCell>{project.name || "N/A"}</TableCell>
                        <TableCell>{project.contract_signature || "N/A"}</TableCell>
                        <TableCell>{project.salesforce_id || "N/A"}</TableCell>
                        <TableCell>{project.type || "N/A"}</TableCell>
                        <TableCell>{project.pvel_manager_user || "N/A"}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => {
                            clearForm();
                            handleEditProject(project.id)
                          }}>
                            <Edit />
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={activeProjects.count || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage=""
            />
          </Paper>

        </>
      )
      }
    </>
  );
};
